import fetchDateAvailability from './fetchDateAvailability';
import updateDateAvailability from './updateDateAvailability';

export default [
  fetchDateAvailability,
  updateDateAvailability,
];
